import './A.scss';

import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

export default class A extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        href: PropTypes.string,
        target: PropTypes.string,
        to: PropTypes.string
    };

    render() {
        let { className, ...otherProps } = this.props;
        if(this.props.to != null) {
            return (
                <Link {...otherProps} className={`c-link ${className || ''}`}>
                    {this.props.children}
                </Link>
            );
        } else {
            return (
                <a {...otherProps} className={`c-link ${className || ''}`}>
                    {this.props.children}
                </a>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/A/index.js